// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../common/Button';
import TemplateDownloaderCheckbox from './TemplateDownloaderCheckbox';
import saveAs from 'file-saver';
// css
import '../../styles/components/sources/TemplateDownloader.scss';


class TemplateDownloader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      settings: {}
    };

    this.handleClickCheckbox = this.handleClickCheckbox.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleClickCheckbox(name, checked) {
    let settings = this.state.settings;
    settings[name] = checked;
    this.setState({ settings });
  }

  isSubmittable() {
    return Object.keys(this.state.settings).some(k => this.state.settings[k]);
  }

  handleSubmit() {
    const { onSubmit } = this.props;

    onSubmit(this.state.settings)
      .then(res => {
        const blob = new Blob([res.data], { type: 'application/zip' });
        saveAs(blob, `dsa_xls_templates_${Date.now()}.zip`);
      });
  }

  getAllTemplateFilesCount(dsaType) {
    return dsaType === 'full' ? 14 : 9;
  }

  render() {
    const TOP_ROW = [
      {
        title: 'All Template Files',
        getDescription: dsaType => `Download templates for all source data types in ${this.getAllTemplateFilesCount(dsaType)} separate files`,
        name: 'allTemplateFiles'
      },
      {
        title: 'Master Template File',
        getDescription: () => 'Download a template for all source data types in 1 master file',
        name: 'masterTemplateFile'
      },
      {
        title: 'Client email templates',
        getDescription: () => 'Download email message templates and instructions for communicating with customers',
        name: 'clientEmailTemplates'
      }
    ];

    const AREA_CHECKBOXES = [
      {
        title: 'IT Operations',
        getDescription: () => 'Server, Network, and Storage data types (3 files)',
        name: 'itOperations',
        isVisible: () => true
      },
      {
        title: 'Application Development',
        getDescription: () => 'Testers & Developers data type (1 file)',
        name: 'applicationDevelopment',
        isVisible: () => true
      },
      {
        title: 'Business Analytics',
        getDescription: () => 'Order Management, Bill & Invoicing, Customer Service, Procurement and Product Delivery data types (5 files)',
        name: 'businessAnalytics',
        isVisible: dsaType => dsaType === 'full'
      },
      {
        title: 'Application Support',
        getDescription: () => 'Database, Application Support, and End User Support data types (3 files)',
        name: 'applicationSupport',
        isVisible: () => true
      },
      {
        title: 'Security, Compliance and Fraud',
        getDescription: () => 'Security Systems and Fraud data types (2 files)',
        name: 'securityComplianceAndFraud',
        isVisible: () => true
      }
    ];

    const { onCancel, allowCancel, dsaType } = this.props;

    return (
      <div className='template-downloader'>
        <div className='template-downloader__row'>
          {TOP_ROW.map(item => (
            <TemplateDownloaderCheckbox
              key={item.name}
              title={item.title}
              description={item.getDescription(dsaType)}
              name={item.name}
              checked={!!this.state.settings[item.name]}
              onClick={this.handleClickCheckbox}
            />
          ))
        }
        </div>
        <div className='template-downloader__row'>
          {AREA_CHECKBOXES
            .filter(item => item.isVisible(this.props.dsaType))
            .map(item => (
              <TemplateDownloaderCheckbox
                key={item.name}
                title={item.title}
                description={item.getDescription(dsaType)}
                name={item.name}
                onClick={this.handleClickCheckbox}
                checked={!!(this.state.settings.allTemplateFiles || this.state.settings[item.name])}
                disabled={this.state.settings.allTemplateFiles}
              />
            ))
          }
        </div>
        <div className='template-downloader__buttons'>
          {allowCancel &&
            <Button
              label='Cancel'
              onClick={onCancel}
            />
          }
          <Button
            label='Download'
            primary
            disabled={!this.isSubmittable()}
            onClick={this.handleSubmit}
          />
        </div>
      </div>
    );
  }
}

TemplateDownloader.defaultProps = {
  allowCancel: true
};

TemplateDownloader.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  allowCancel: PropTypes.bool,
  dsaType: PropTypes.string.isRequired
};

export default TemplateDownloader;



// WEBPACK FOOTER //
// ./src/components/sources/TemplateDownloader.js